import React from 'react';

import {Header} from './header';
import { New_footer as SimpleFooter } from '../base-template/footer/footer';

import { useEmbedMode } from '../../../features';

import './style.scss';

interface IBaseTemplate  { 
  children: React.ReactNode
}

export default function Layout({ children}: IBaseTemplate) {
  const { isEmbeddedMode } = useEmbedMode();
  return (
    <div className="base-template">
      {!isEmbeddedMode && <Header />}
      {children}
      {!isEmbeddedMode && <SimpleFooter />}
    </div>
  );
}